import type { MetaDescriptor } from 'react-router';

/**
 * @returns
 * @param noIndex
 * @param noFollow
 * @param metaDescriptors
 * @param isIndexPage
 */
export const noIndexNoFollow = (
    noIndex: boolean,
    noFollow: boolean,
    isIndexPage: boolean,
    metaDescriptors: MetaDescriptor[],
): MetaDescriptor[] => {
    const noIndexTagIndex = metaDescriptors.findIndex((descriptor) => {
        return (
            'name' in descriptor &&
            descriptor.name === 'robots' &&
            ((descriptor.content as string).includes('noindex') ||
                (descriptor.content as string).includes('nofollow'))
        );
    });

    // remove current robots meta tag
    if (noIndexTagIndex !== -1) {
        metaDescriptors.splice(noIndexTagIndex, 1);
    }

    // add new robots if this page isn't index only
    if (!isIndexPage) {
        const updatedRobots = [];

        if (noIndex) updatedRobots.push('noindex');
        if (noFollow) updatedRobots.push('nofollow');

        if (updatedRobots.length > 0) {
            metaDescriptors.push({
                name: 'robots',
                content: updatedRobots.join(', '),
            });
        }
    }

    return metaDescriptors;
};
